import { createAction, createSlice } from "@reduxjs/toolkit";

const getNewestCoursesSlice = createSlice({
  name: "getNewestCourses",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      const { data } = action.payload;
      state.data = data.data;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getNewestCoursesSlice;
const getNewestCoursesAction = createAction(name);

export {
  getNewestCoursesAction,
  actions as getNewestCoursesActions,
  reducer as getNewestCoursesReducer,
};
